import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const FLOW_SLICE_INITIAL = {
  isInPreviousStep: false,
  isLoading: false
} satisfies FlowState as FlowState;

type FlowState = {
  //indicates if the current substep was reached by clicking on "go to previous step".
  //useful to not submit when we go to previous step in the missing fields flow
  isInPreviousStep: boolean;
  isLoading: boolean;
};

export const flowSlice = createSlice({
  name: "flow",
  initialState: FLOW_SLICE_INITIAL,

  reducers: {
    setIsInPreviousStep: (state, action: PayloadAction<boolean>) => {
      state.isInPreviousStep = action.payload;
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    }
  }
});

export const { setIsInPreviousStep, setIsLoading } = flowSlice.actions;
